// Formatting shared by the fun-stat displays (results screen, profile).
// Game distance is in arena pixels; ~20 px reads as a meter, which lands typical
// matches in the fun "you wormed 1.4 km" range.
export const PX_PER_METER = 20;

export function formatDistancePx(px: number): string {
  const meters = px / PX_PER_METER;
  if (meters >= 1000) return (meters / 1000).toFixed(1) + " km";
  return Math.round(meters) + " m";
}

export function formatDuration(seconds: number): string {
  const s = Math.round(seconds);
  if (s < 90) return s + "s";
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m} min`;
}
